<script>
import { mapGetters } from "vuex";

// Shared by every buy/reserve/mark-as-bought control on a locked (demo)
// list: `demoLockGuard` (bound with `@click.capture` / `@click.native.capture`)
// swallows the click before the real action runs and opens the centered
// DemoLockMessage modal instead - works the same on desktop click and
// mobile tap. Applied directly on the real button/component - never through
// a wrapper element - so it can't interfere with the surrounding layout
// (flex `margin: auto` tricks, grid placement, etc. all keep working
// exactly as before).
//
// There used to also be a hover tooltip here (v-tooltip). Dropped it: a
// positioned tooltip has no reliable anchor/space on a small viewport, and
// its own hover listener made iOS require two taps (one to simulate hover,
// one to actually click) before the modal would even open.
export default {
  computed: {
    ...mapGetters({
      isLockedList: "isLockedList",
    }),
  },
  methods: {
    demoLockGuard(event) {
      if (!this.isLockedList) return;
      event.stopPropagation();
      event.preventDefault();
      this.$store.commit("setDemoLockMessage", true);
    },
  },
};
</script>
